import EventsWidget from './EventsWidget.vue';

export default EventsWidget;
